module.exports = __webpack_public_path__ + "img/Slice39.4db30517.png";